import * as rxjs from 'rxjs';
import * as rxjsOperators from 'rxjs/operators';

import { apiResponseFormatter } from '../formatters/apiResponse';

export class StorageService {
  public get<T = any>(key: string): rxjs.Observable<T> {
    return rxjs.of(true).pipe(
      rxjsOperators.map(() => localStorage.getItem(key)),
      rxjsOperators.map((data) =>
        data ? apiResponseFormatter(JSON.parse(data)) : null
      ),
      rxjsOperators.catchError(() => rxjs.of(null))
    );
  }

  public getPromised<T = any>(key: string): Promise<T> {
    return this.get<T>(key).toPromise();
  }

  public async setPromised<T = any>(key: string, value: T): Promise<T> {
    await this.set<T>(key, value).toPromise();

    return value;
  }

  public set<T = any>(key: string, value: T): rxjs.Observable<T> {
    return rxjs.of(true).pipe(
      rxjsOperators.map(() => localStorage.setItem(key, JSON.stringify(value))),
      rxjsOperators.map(() => value)
    );
  }

  public clear(regexp: RegExp): rxjs.Observable<void> {
    return rxjs.of(Object.keys(localStorage)).pipe(
      rxjsOperators.map((keys) => {
        if (regexp) {
          keys = keys.filter((k) => regexp.test(k));
        }

        keys.forEach((k) => localStorage.removeItem(k));
        return null;
      })
    );
  }

  public purge() {
    localStorage.clear();
  }
}

const storageService = new StorageService();
export default storageService;
